import { useState, useEffect } from 'react';
import SubscriptionClient, {
  PaymentMethods
} from 'src/services/SubscriptionClient';

interface UsePaymentMethodsParams {
  authProvider: any;
  stack?: any;
  paymentMethodId?: string;
}

interface UsePaymentMethodsResult {
  paymentMethods: PaymentMethods | null;
  loading: boolean;
  error: Error | null;
}

export const usePaymentMethods = ({
  authProvider,
  stack,
  paymentMethodId
}: UsePaymentMethodsParams): UsePaymentMethodsResult => {
  const [paymentMethods, setPaymentMethods] = useState<PaymentMethods | null>(
    null
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!authProvider || !paymentMethodId) return;

    const fetchPaymentMethods = async () => {
      setLoading(true);
      setError(null);

      try {
        const client = new SubscriptionClient(authProvider, stack);
        const data = await client.getPaymentMethods(paymentMethodId);
        setPaymentMethods(data);
      } catch (err) {
        setError(err as Error);
      } finally {
        setLoading(false);
      }
    };

    fetchPaymentMethods();
  }, [authProvider, stack, paymentMethodId]);

  return {
    paymentMethods,
    loading,
    error
  };
};

export default usePaymentMethods;
